module.exports = __webpack_public_path__ + "img/empty-search.056dcb44.svg";